Namespace 'Customer.Filters'

class Customer.Filters.VisibleByCardView extends Backbone.View
  template: JST['backbone/templates/customer/filters/tabs/general/visible_by_card']
  className: 'filter-field-container'

  initialize: ({filter, editable, usersGroups}) ->
    @filter = filter
    @editable = editable
    @usersGroups = usersGroups

  render: ->
    @$el.html(@template)
    @_addVisibleBySelector()
    @

  getVisibleBy: =>
    @visibleByGroupsView.toArray()

  _keepCustomerSessionAlive: ->
    Backbone.trigger 'customerSession:keepAlive'

  _addVisibleBySelector: ->
    $selectContainer = @$('#filter-visible-by')
    @visibleByGroupsView = @_selectView()
    $selectContainer.append(@visibleByGroupsView.el)
    @listenTo(@visibleByGroupsView, 'change', @_keepCustomerSessionAlive)
    @toggle @filter.isGlobal()

  _selectView: ->
    new Customer.Filters.DropupSelectView
      options: @usersGroups
      valueProperty: 'id'
      descriptionProperty: 'name'
      selectedOptions: @filter.get('users_group_ids')
      placeholder: I18n.t('customer.dashboard.filters.placeholders.add_user_group')
      disabledPlaceholder: I18n.t('customer.dashboard.filters.placeholders.not_public')
      title: I18n.t('customer.dashboard.filters.creation.visible_by')
      editable: @editable

  toggle: (isPublic) ->
    @$el.toggleClass 'filter-disabled', not isPublic
    if isPublic
      @visibleByGroupsView.enable()
    else
      @visibleByGroupsView.disable()
